var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"bid-left-top"},[_c('div',{staticClass:"bid-title"},[_vm._v("Countdown to Next Round : "),_c('span',{staticClass:"bid-blocknum"},[_vm._v(_vm._s(_vm.blocknum))]),_vm._v(" Blocks\n    ")])])}
var staticRenderFns = []
render._withStripped = true
export { render, staticRenderFns }